export interface PaymentModelDatabase {
  uuid: string;
  retailerId: number;
  paymentMethodTypeCode: string;
  updateDate: string;
  updateUserId: number;
}

export interface PaymentModelClient {
  accountName: string;
  bankAccountType: string;
  branchCode: string;
  bankAccountNumber: string;
  paymentType: string;
  uuid?: string;
}

export interface ValidateRequest {
  accountNumber: string;
  branchCode: string;
  accountType: string;
}

export enum PaymentTypeName {
  YOCO = "YOCO",
  STD_BANK = "STD_BANK",
}
export interface PaymentMethodType {
  uuid: string;
  typeCode: string;
  typeName: string;
  createDate: string;
}

export interface AccountType {
  type: string;
  code: string;
}

export interface BankOption {
  bankName: string;
  centralBranchCode: string;
}



